<img loading="lazy" width="100%" [style.height]="height" [ngStyle.lt-md]="{'height':heightMob}"
    (click)="navigation==0?goToCategories(catId):link(navigatedUrl)"

    
    [src]="image" [alt]="altImage || 'images'" loading="lazy">